module.exports = __webpack_public_path__ + "static/media/exportIntegration.c48a6ce0.svg";